<template>
  <div class="popluar-clips-listing">
    <div class="popluar-clips infinite-scroll">
      <div class="item-list">
        <div
          v-for="clip in clips"
          :key="clip.id"
          class="col-md-4 col-sm-6 col-xs-12 no-margin featured-wraper no-padding"
          style="margin-bottom: 20px"
        >
          <div class="popluar-clip three-grid">
            <div class="popluar-clips-container">
              <div class="popluar-clip-header">
                <a
                  :href="route('user.clip.show', { slug: clip.slug })"
                  class="category"
                >
                  <small>{{ getCategories(clip) }}</small>
                </a>
                <h3>
                  <a
                    :href="route('user.clip.show', { slug: clip.slug })"
                    class="text-capitalize"
                    >{{ clip.title }}</a
                  >
                </h3>
              </div>
              <div class="popular-clip-author">
                <a
                  :href="userUrl(clip.user.slug)"
                  v-if="clip.user && clip.user.user_type === '0'"
                  >by {{ clip.user.first_name }}</a
                >
                <a :href="userUrl(clip.user.slug)" v-else-if="clip.user"
                  >by {{ clip.user.first_name + " " + clip.user.last_name }}</a
                >
                <a href="#" v-else>by</a>
              </div>
              <div class="popluar-clip-content-wrapper">
                <div v-if="clip.image !== '' && clip.image !== 'NULL'">
                  <div class="popluar-clip-content has-img">
                    <hr />
                    <div class="image">
                      <div class="popluar-clip-image">
                        <a :href="route('user.clip.show', { slug: clip.slug })">
                          <img
                            v-bind:src="getClipCoverImage(clip)"
                            :alt="clip.title"
                            class="clip-image"
                            width="100%"
                            height="100%"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-else-if="clip.cliptype == 'audio'"
                  v-html="clip.audio"
                ></div>
                <div v-else-if="clip.cliptype == 'video'" v-html="clip.video">
                  <!-- {{ clip.video }} -->
                </div>
                <div v-else-if="clip.content != ''">
                  <a :href="route('user.clip.show', { slug: clip.slug })">
                    <div class="popluar-clip-content has-text">
                      <hr />
                      <div
                        class="markup-content"
                        v-html="
                          $options.filters.getWords(clip.content, 81, '...')
                        "
                      ></div>
                    </div>
                  </a>
                </div>
                <div v-if="is_admin" class="popluar-clip-image-overlay">
                  <div
                    class="image-overlay-buttons text-center text-uppercase flex"
                  >
                    <a
                      style="text-decoration: none; cursor: pointer"
                      @click="
                        updateFavorites(
                          clip.id,
                          clip.is_public,
                          clip.is_featured
                        )
                      "
                      class="colorWhite brandon_grotesque_medium btn-font-big btn-gray-dark"
                      >{{
                        setFavUnfavLabel(
                          clip.is_featured,
                          this.brand_details["brand_name"] || "CBE"
                        )
                      }}</a
                    >
                    <a
                      style="text-decoration: none; cursor: pointer"
                      href="javascript:void(0);"
                      class="colorWhite brandon_grotesque_medium btn-font-big btn-gray-dark"
                      >Block From
                      {{ this.brand_details["brand_name"] || "CBE" }}</a
                    >
                    <a
                      style="text-decoration: none; cursor: pointer"
                      @click.prevent="showClipToBookModal(clip)"
                      class="colorWhite brandon_grotesque_medium btn-font-big btn-gray-dark"
                      >Add To
                      {{ this.brand_details["brand_name"] || "CBE" }}
                      Template</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="popluar-clip-footer">
              <hr />
              <ul>
                <li class="pull-left">
                  <a
                    v-if="current_user"
                    class="btn text-capitalize"
                    id="show-clip-to-book-modal"
                    @click.prevent="showClipToBookModal(clip)"
                  >
                    <i class="fa fa-plus"></i>
                    <span class="custom-grey-label"
                      >Add to {{ trans("book.singular") }}</span
                    >
                  </a>
                  <a
                    v-else
                    href="user/login"
                    class="btn text-capitalize list-action-guest"
                    data-toggle="modal"
                    data-keyboard="true"
                    data-target="#loginModal"
                    data-type="SaveClip"
                    :data-id="clip.id"
                  >
                    <i class="fa fa-plus"></i>
                    <span class="custom-grey-label"
                      >Add to {{ trans("book.singular") }}</span
                    >
                  </a>
                </li>
                <li class="pull-right">
                  <div v-if="current_user">
                    <a
                      :href="editUrl(clip.slug)"
                      class="list-action btn btn-dark"
                      v-if="current_user.id == clip.user_id"
                    >
                      <i class="fa fa-pencil"></i>
                      <span class="text-capitalize"
                        >Edit {{ trans("clip.singular") }}</span
                      >
                    </a>
                    <save-clip
                      v-else
                      :clip="clip.id"
                      :saved="checkSavedClip(clip.id)"
                    ></save-clip>
                  </div>
                  <a
                    v-else
                    href="user/login"
                    class="list-action-guest btn btn-dark"
                    data-toggle="modal"
                    data-keyboard="true"
                    data-target="#loginModal"
                    data-type="SaveClip"
                    :data-id="clip.id"
                  >
                    <i class="fa fa-star"></i>
                    <span class="text-capitalize"
                      >Save {{ trans("clip.singular") }}</span
                    >
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div v-if="busy === true" class="row">
      <div class="col-md-12 text-center loader-section">
        <p>
          <img src="/themes/front/img/loading.gif" alt="loading" />
        </p>
        <p>
          <small>Loading Content</small>
        </p>
      </div>
    </div>

    <div
      id="setting-clip"
      class="modal fade text-left"
      :class="clipsettingModalClass"
      tabindex="-1"
      role="dialog"
    >
      <div class="setting modal-dialog">
        <!-- Modal content-->
        <div class="overlay-title">
          <h3 class="text-capitalize">Settings {{ trans("clip.singular") }}</h3>
        </div>
        <div class="setting modal-content">
          <div class="setting modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              @click="closeModal"
            >
              <i class="fa fa-times"></i>
            </button>
            <h2 class="title">{{ current_clip.title }}</h2>
            <hr />
            <h3 class="text-capitalize">
              {{ trans("clip.singular") }} privacy options
            </h3>
            <br />
            <p>
              Select public allows other Haggadot Community members to use your
              public {{ trans("clip.singular") }} in their
              {{ trans("book.Multiple") }}.
            </p>
            <br />

            <div class="row custom-radio-section">
              <div class="col-sm-3">
                <input
                  type="radio"
                  class="field"
                  name="is_public"
                  id="partner_popular_public_radio"
                  value="1"
                  :checked="current_clip.is_public == 1"
                />
                <label for="partner_popular_public_radio">Public</label>
              </div>
              <div class="col-sm-3">
                <input
                  type="radio"
                  class="field"
                  name="is_public"
                  id="partner_popular_private_radio"
                  value="0"
                  :checked="current_clip.is_public == 0"
                />
                <label for="partner_popular_private_radio">Private</label>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3 custom-checkbox-section">
                <input
                  type="checkbox"
                  class="field"
                  name="is_featured"
                  :value="1"
                  id="partner_popular_featured_checkbox"
                  :checked="current_clip.is_featured == 1"
                />
                <label for="partner_popular_featured_checkbox"
                  >Make Feature</label
                >
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="reading-list col-md-12">
                <input
                  type="button"
                  value="SAVE"
                  class="setting-btn colorWhite brandon_grotesque_medium btn-font-big btn btn-lg btn-primary-color"
                  @click="updateClipSetting()"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="clipsettingModalClass"
      class="modal-backdrop fade"
      :class="clipsettingModalClass"
    ></div>
    <div
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="busy"
      infinite-scroll-distance="0"
    ></div>
  </div>
</template>

<script>
import infiniteScroll from "vue-infinite-scroll";

var count = 0;
export default {
  props: ["clipList", "current_user", "bookList", "page", "token", "is_admin"],
  directives: { infiniteScroll },
  data() {
    return {
      csrf_token: this.token,
      clips: this.clipList,
      loggedin_user: this.current_user,
      data: [],
      busy: false,
      allfatched: false,
      clipsettingModalClass: "",
      current_clip: [],
    };
  },
  components: {
    "my-component": require("./saveClip.vue"),
  },
  filters: {
    getWords: function (value, return_words, last_word = "") {
      if (!value) return "";
      value.replace("\n", "");
      if (value.length > return_words) {
        return value.split(/\s+/).slice(0, return_words).join(" ") + last_word;
      }
      return value;
    },
    coverImage(src) {
      var src_path = src.split("/");
      src_path.pop();
      src_path.push("conversions");
      src_path.push("cover.jpg");

      var result = src_path.join("/");
      return result;
    },
  },
  methods: {
    setFavUnfavLabel(is_featured, clip_term) {
      if (is_featured == 1) {
        return "Remove From " + clip_term + " Fav";
      }
      return "Make " + clip_term + " Fav";
    },
    getClipCoverImage: function (clip) {
      // if(clip.media && clip.media.length){
      // 	var media = clip.media[clip.media.length-1]
      // 	return 'uploads/clips/'+media.id+'/conversions/cover.jpg'
      // }

      return clip.default_clip_image;
    },
    editUrl(clip_id) {
      return this.route("user.clip.edit", { slug: clip_id });
    },
    closeModal() {
      this.current_clip = [];
      this.clipsettingModalClass = "";
    },
    showClipSettingModal(clip) {
      this.current_clip = clip;
      this.clipsettingModalClass = "in";
    },
    updateClipSetting() {
      var is_public = $('.setting input[name="is_public"]:checked').val() || 0;
      var is_featured =
        $('.setting input[name="is_featured"]:checked').val() || 0;
      axios
        .patch(
          this.route("user.clip.updateSetting", { id: this.current_clip.id }),
          {
            is_public: is_public,
            is_featured: is_featured,
          }
        )
        .then((response) => {
          this.closeModal();
          location.reload();
        })
        .catch();
    },
    updateFavorites(clip_id, is_public, is_featured) {
      if (is_featured == 0) {
        axios
          .patch(this.route("user.clip.updateSetting", { id: clip_id }), {
            is_public: is_public,
            is_featured: is_featured,
          })
          .then((response) => {
            location.reload();
          })
          .catch();
      }
      if (is_featured == 1) {
        axios
          .patch(this.route("user.clip.updateSetting", { id: clip_id }), {
            is_public: is_public,
          })
          .then((response) => {
            location.reload();
          })
          .catch();
      }
    },
    /* blockClip(clip_id){
        axios.post("/clip/" + clip_id, {
          _method: 'DELETE'
        })
        .then( response => {
          location.reload();
        })
        .catch( error => {
          //handle failure
        })
    }, */
    loadMore: function () {
      var vm = this; //declare this
      var list = [];
      if (vm.allfatched !== true) {
        this.busy = true;
        count++;
        var url = window.location.href;
        // console.log("test =>  "+ url);
        if (url.indexOf("?") == -1) {
          url += "?";
        } else {
          url += "&";
        }
        url += "page=" + count;
        // console.log(url);
        setTimeout(() => {
          axios.get(url).then((response) => {
            if (response.data.length > 0) {
              $.each(response.data, function (index, clip) {
                vm.clips.push(clip);
              });
            } else {
              vm.allfatched = true;
            }
          });
          this.busy = false;
        }, 1000);
      }
    },
    checkSavedClip(id) {
      var vm = this; //declare this
      var status = false;

      if (this.loggedin_user && this.loggedin_user.saved_clips.length > 0) {
        var saved_clips = this.loggedin_user.saved_clips;

        $.each(saved_clips, function (index, clip) {
          if (clip.id == id) {
            status = true;
          }
        });
      }
      return status;
    },
    getCategories(clip) {
      var section = "";
      if (clip.type_of_customs) {
        var total_ele = Object.keys(clip.type_of_customs).length;
        clip.type_of_customs.forEach((section_data, index) => {
          section += section_data["name"];
          if (index + 1 < total_ele) {
            section += ", ";
          }
        });
      }
      return section;
    },
    permittedUser() {
      if (this.is_admin) {
        return true;
      }
      return false;
    },
    showClipToBookModal(clip) {
      this.$root.showClipToBookModal(
        true,
        clip.id,
        clip.title,
        clip.section && clip.section.id ? clip.section.id : "",
        clip.section && clip.section.name ? clip.section.name : ""
      );
    },
    userUrl(slug) {
      return this.route("user.show", { slug: slug });
    },
  },
};
</script>
